import {Component, ElementRef, ViewChild} from '@angular/core';
import { DataService } from 'app/data.service';

@Component({
   selector: 'app-sign-menu',
   templateUrl: './sign-menu.component.html',
   styleUrls: ['./sign-menu.component.css']
})
export class SignMenuComponent {
   @ViewChild('search', { static: true }) search: ElementRef;

   constructor(public dataService: DataService) {
   }

   clearSearchData() {
      if (this.search) {
         this.search.nativeElement.value = '';
      }
      sessionStorage.removeItem('tpSearch');
   }

   expand(senderList: any) {
      if (!senderList.isExpanded() && this.dataService.senderObject.isExpand) {
         senderList.toggle();
      }
      this.clearSearchData();
   }
}
